export const message = {
  root: {
    borderRadius: "{content.border.radius}",
    borderWidth: "{border.width.1}",
    transitionDuration: "{transition.duration}",
  },
  content: {
    padding: "{padding.8} {padding.12}",
    gap: "{gap.12}",
    sm: {
      padding: "{padding.4} {padding.8}",
    },
    lg: {
      padding: "{padding.12} {padding.16}",
    },
  },
  text: {
    fontSize: "{content.font.size}",
    fontWeight: "{content.font.weight}",
    sm: {
      fontSize: "calc({content.font.size} * 0.85)",
    },
    lg: {
      fontSize: "calc({content.font.size} * 1.15)",
    },
  },
  icon: {
    size: "{message.text.font.size}",
    sm: {
      size: "{message.text.sm.font.size}",
    },
    lg: {
      size: "{message.text.lg.font.size}",
    },
  },
  // closeButton: {
  //   width: "1.75rem",
  //   height: "1.75rem",
  //   borderRadius: "50%",
  //   focusRing: {
  //     width: "{focus.ring.width}",
  //     style: "{focus.ring.style}",
  //     offset: "{focus.ring.offset}",
  //   },
  // },
  // closeIcon: {
  //   size: "1rem",
  //   sm: {
  //     size: "0.875rem",
  //   },
  //   lg: {
  //     size: "1.125rem",
  //   },
  // },
  outlined: {
    root: {
      borderWidth: "{border.width.1}",
    },
  },
  simple: {
    content: {
      padding: "0",
    },
  },
  info: {
    background: "{info.support}",
    // borderColor: "{blue.200}",
    color: "{info.default}",
    // shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)",
    // closeButton: {
    //   hoverBackground: "{blue.100}",
    //   focusRing: {
    //     color: "{blue.600}",
    //     shadow: "none",
    //   },
    // },
    // outlined: {
    //   color: "{blue.600}",
    //   borderColor: "{blue.600}",
    // },
    simple: {
      color: "{info.default}",
    },
  },
  success: {
    background: "{success.support}",
    // borderColor: "{green.200}",
    color: "{success.default}",
    // shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)",
    // closeButton: {
    //   hoverBackground: "{green.100}",
    //   focusRing: {
    //     color: "{green.600}",
    //     shadow: "none",
    //   },
    // },
    // outlined: {
    //   color: "{green.600}",
    //   borderColor: "{green.600}",
    // },
    simple: {
      color: "{success.default}",
    },
  },
  warn: {
    background: "{warning.support}",
    // borderColor: "{yellow.200}",
    color: "{warning.default}",
    // shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)",
    // closeButton: {
    //   hoverBackground: "{yellow.100}",
    //   focusRing: {
    //     color: "{yellow.600}",
    //     shadow: "none",
    //   },
    // },
    // outlined: {
    //   color: "{yellow.600}",
    //   borderColor: "{yellow.600}",
    // },
    simple: {
      color: "{warning-soft.default}",
    },
  },
  error: {
    background: "{danger.support}",
    // borderColor: "{red.200}",
    color: "{danger.default}",
    // shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)",
    // closeButton: {
    //   hoverBackground: "{red.100}",
    //   focusRing: {
    //     color: "{red.600}",
    //     shadow: "none",
    //   },
    // },
    // outlined: {
    //   color: "{danger.default}",
    //   borderColor: "{danger.default}",
    // },
    simple: {
      color: "{danger.default}",
    },
  },
  // secondary: {
  //   background: "{surface.100}",
  //   borderColor: "{surface.200}",
  //   color: "{surface.600}",
  //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)",
  //   closeButton: {
  //     hoverBackground: "{surface.200}",
  //     focusRing: {
  //       color: "{surface.600}",
  //       shadow: "none",
  //     },
  //   },
  //   outlined: {
  //     color: "{surface.500}",
  //     borderColor: "{surface.500}",
  //   },
  //   simple: {
  //     color: "{surface.500}",
  //   },
  // },
  // contrast: {
  //   background: "{surface.900}",
  //   borderColor: "{surface.950}",
  //   color: "{surface.50}",
  //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)",
  //   closeButton: {
  //     hoverBackground: "{surface.800}",
  //     focusRing: {
  //       color: "{surface.50}",
  //       shadow: "none",
  //     },
  //   },
  //   outlined: {
  //     color: "{surface.950}",
  //     borderColor: "{surface.950}",
  //   },
  //   simple: {
  //     color: "{surface.950}",
  //   },
  // },
  colorScheme: {
    light: {
      info: {
        background: "{info.support}",
        // borderColor: "{blue.200}",
        color: "{info.default}",
        // shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)",
        // closeButton: {
        //   hoverBackground: "{blue.100}",
        //   focusRing: {
        //     color: "{blue.600}",
        //     shadow: "none",
        //   },
        // },
        // outlined: {
        //   color: "{blue.600}",
        //   borderColor: "{blue.600}",
        // },
        simple: {
          color: "{info.default}",
        },
      },
      success: {
        background: "{success.support}",
        // borderColor: "{green.200}",
        color: "{success.default}",
        // shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)",
        // closeButton: {
        //   hoverBackground: "{green.100}",
        //   focusRing: {
        //     color: "{green.600}",
        //     shadow: "none",
        //   },
        // },
        // outlined: {
        //   color: "{green.600}",
        //   borderColor: "{green.600}",
        // },
        simple: {
          color: "{success.default}",
        },
      },
      warn: {
        background: "{warning.support}",
        // borderColor: "{yellow.200}",
        color: "{warning.default}",
        // shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)",
        // closeButton: {
        //   hoverBackground: "{yellow.100}",
        //   focusRing: {
        //     color: "{yellow.600}",
        //     shadow: "none",
        //   },
        // },
        // outlined: {
        //   color: "{yellow.600}",
        //   borderColor: "{yellow.600}",
        // },
        simple: {
          color: "{warning-soft.default}",
        },
      },
      error: {
        background: "{danger.support}",
        // borderColor: "{red.200}",
        color: "{danger.default}",
        // shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)",
        // closeButton: {
        //   hoverBackground: "{red.100}",
        //   focusRing: {
        //     color: "{red.600}",
        //     shadow: "none",
        //   },
        // },
        // outlined: {
        //   color: "{danger.default}",
        //   borderColor: "{danger.default}",
        // },
        simple: {
          color: "{danger.default}",
        },
      },
      // secondary: {
      //   background: "{surface.100}",
      //   borderColor: "{surface.200}",
      //   color: "{surface.600}",
      //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)",
      //   closeButton: {
      //     hoverBackground: "{surface.200}",
      //     focusRing: {
      //       color: "{surface.600}",
      //       shadow: "none",
      //     },
      //   },
      //   outlined: {
      //     color: "{surface.500}",
      //     borderColor: "{surface.500}",
      //   },
      //   simple: {
      //     color: "{surface.500}",
      //   },
      // },
      // contrast: {
      //   background: "{surface.900}",
      //   borderColor: "{surface.950}",
      //   color: "{surface.50}",
      //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)",
      //   closeButton: {
      //     hoverBackground: "{surface.800}",
      //     focusRing: {
      //       color: "{surface.50}",
      //       shadow: "none",
      //     },
      //   },
      //   outlined: {
      //     color: "{surface.950}",
      //     borderColor: "{surface.950}",
      //   },
      //   simple: {
      //     color: "{surface.950}",
      //   },
      // },
    },
    dark: {
      info: {
        background: "{info.support}",
        // borderColor: "{blue.200}",
        color: "{info.default}",
        // shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)",
        // closeButton: {
        //   hoverBackground: "{blue.100}",
        //   focusRing: {
        //     color: "{blue.600}",
        //     shadow: "none",
        //   },
        // },
        // outlined: {
        //   color: "{blue.600}",
        //   borderColor: "{blue.600}",
        // },
        simple: {
          color: "{info.support}",
        },
      },
      success: {
        background: "{success.support}",
        // borderColor: "{green.200}",
        color: "{success.default}",
        // shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)",
        // closeButton: {
        //   hoverBackground: "{green.100}",
        //   focusRing: {
        //     color: "{green.600}",
        //     shadow: "none",
        //   },
        // },
        // outlined: {
        //   color: "{green.600}",
        //   borderColor: "{green.600}",
        // },
        simple: {
          color: "{success.support}",
        },
      },
      warn: {
        background: "{warning.support}",
        // borderColor: "{yellow.200}",
        color: "{warning.default}",
        // shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)",
        // closeButton: {
        //   hoverBackground: "{yellow.100}",
        //   focusRing: {
        //     color: "{yellow.600}",
        //     shadow: "none",
        //   },
        // },
        // outlined: {
        //   color: "{yellow.600}",
        //   borderColor: "{yellow.600}",
        // },
        simple: {
          color: "{warning-soft.support}",
        },
      },
      error: {
        background: "{danger.support}",
        // borderColor: "{red.200}",
        color: "{danger.default}",
        // shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)",
        // closeButton: {
        //   hoverBackground: "{red.100}",
        //   focusRing: {
        //     color: "{red.600}",
        //     shadow: "none",
        //   },
        // },
        // outlined: {
        //   color: "{danger.default}",
        //   borderColor: "{danger.default}",
        // },
        simple: {
          color: "{danger.support}",
        },
      },
      // secondary: {
      //   background: "{surface.100}",
      //   borderColor: "{surface.200}",
      //   color: "{surface.600}",
      //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)",
      //   closeButton: {
      //     hoverBackground: "{surface.200}",
      //     focusRing: {
      //       color: "{surface.600}",
      //       shadow: "none",
      //     },
      //   },
      //   outlined: {
      //     color: "{surface.500}",
      //     borderColor: "{surface.500}",
      //   },
      //   simple: {
      //     color: "{surface.500}",
      //   },
      // },
      // contrast: {
      //   background: "{surface.900}",
      //   borderColor: "{surface.950}",
      //   color: "{surface.50}",
      //   shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)",
      //   closeButton: {
      //     hoverBackground: "{surface.800}",
      //     focusRing: {
      //       color: "{surface.50}",
      //       shadow: "none",
      //     },
      //   },
      //   outlined: {
      //     color: "{surface.950}",
      //     borderColor: "{surface.950}",
      //   },
      //   simple: {
      //     color: "{surface.950}",
      //   },
      // },
    },
  },
  css: (): string => `
    .p-message-text a {
      color: inherit;
      text-decoration: underline;
    }
  `,
};
